interface FlagIconProps {
  code: string;
  className?: string;
}

const flags: Record<string, React.ReactNode> = {
  sv: (
    <svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#005baa" d="M0 0h640v480H0z" />
      <path fill="#fecb00" d="M176 0h80v480h-80zM0 200h640v80H0z" />
    </svg>
  ),
  da: (
    <svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#c8102e" d="M0 0h640v480H0z" />
      <path fill="#fff" d="M205 0h64v480h-64zM0 208h640v64H0z" />
    </svg>
  ),
  fi: (
    <svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#003580" d="M176 0h64v480h-64zM0 208h640v64H0z" />
    </svg>
  ),
  no: (
    <svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#ba0c2f" d="M0 0h640v480H0z" />
      <path fill="#fff" d="M180 0h100v480H180zM0 190h640v100H0z" />
      <path fill="#00205b" d="M204 0h52v480h-52zM0 214h640v52H0z" />
    </svg>
  ),
  en: (
    <svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#012169" d="M0 0h640v480H0z" />
      <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z" />
      <path fill="#C8102E" d="m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z" />
      <path fill="#FFF" d="M241 0v480h160V0zM0 160v160h640V160z" />
      <path fill="#C8102E" d="M0 193v96h640v-96zM273 0v480h96V0z" />
    </svg>
  ),
};

export function FlagIcon({ code, className = "w-5 h-4" }: FlagIconProps) {
  const flag = flags[code];
  if (!flag) return null;

  return (
    <span className={`inline-block rounded-sm overflow-hidden shadow-sm ${className}`} aria-hidden="true">
      {flag}
    </span>
  );
}
